export default "__VITE_ASSET__CDn_$8x1__"